import { Action, createReducer, on } from '@ngrx/store';
import { fromProductSubTypesAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productSubTypesFeatureKey = 'productSubTypes';

export interface ProductSubTypesState {
  productSubTypesResponse: IStaticDataResponse[];
  productSubTypesFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductSubTypesState = {
  productSubTypesFailure: undefined,
  productSubTypesResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductSubTypesAction.loadProductSubTypes, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductSubTypesAction.loadProductSubTypesSuccess, (state, action) => ({
    ...state,
    productSubTypesResponse: action.response
  })),

  on(fromProductSubTypesAction.loadProductSubTypesFailure, (state, action) => ({
    ...state,
    productSubTypesFailure: action.error
  }))
);

export const getProductSubTypesResponse = (state: ProductSubTypesState) => state.productSubTypesResponse;
export const getProductSubTypesFailure = (state: ProductSubTypesState) => state.productSubTypesFailure;
export const getProductSubTypesIsLoaded = (state: ProductSubTypesState) => state.loaded;
